<template>
    <div class="row">
        <div class="col-12">
            <div class="card card-form company-card">
                <div class="card-header profile">
                    <div class="row">
                        <div class="col-12">
                            <div class="pull-left">
                                <span><i class="fa fa-user-circle"></i> {{$t('company.profile.label')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <drop-zone code="companyLogo"
                                   label="company.field.docCompanyLogo"
                                   view="LOGO"
                                   folder="Company"
                                   subFolder="CompanyLogo"
                                   :addRemoveLinks="hasCreate"
                                   :editable="hasCreate"
                                   :data="companyProfile.logos"
                                   @change="(files) => {companyProfile.companyLogo = files[0]}"
                                   :maxFiles="1"
                                   acceptedFiles="image/*"
                                   :has-error="$v.companyProfile.companyLogo.id.$error"
                        ></drop-zone>
                        <div class="col-md-8">
                            <div class="form-group">
                                <label>{{$t('company.field.name')}} <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="companyProfile.name"
                                       :class="{invalid: $v.companyProfile.name.$error}"
                                >
                                <div class="red" v-if="!$v.companyProfile.name.required">{{$t('company.validation.name')}}</div>
                                <div class="red" v-if="!$v.companyProfile.name.maxLength">{{$t('company.validation.nameMaxLength')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.shortName')}} <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="companyProfile.shortName"
                                       :class="{invalid: $v.companyProfile.shortName.$error}"
                                >
                                <div class="red" v-if="!$v.companyProfile.shortName.required">{{$t('company.validation.shortName')}}</div>
                                <div class="red" v-if="!$v.companyProfile.shortName.maxLength">{{$t('company.validation.shortNameMax')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.nameRu')}} <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="companyProfile.nameRu"
                                       :class="{invalid: $v.companyProfile.nameRu.$error}"
                                >
                                <div class="red" v-if="!$v.companyProfile.nameRu.required">{{$t('company.validation.name')}}</div>
                                <div class="red" v-if="!$v.companyProfile.nameRu.maxLength">{{$t('company.validation.nameMaxLength')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.description')}} <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="companyProfile.description"
                                       :class="{invalid: $v.companyProfile.description.$error}"
                                >
                                <div class="red" v-if="!$v.companyProfile.description.required">{{$t('company.validation.description')}}</div>
                                <div class="red" v-if="!$v.companyProfile.description.maxLength">{{$t('company.validation.descriptionMax')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.address')}} <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="companyProfile.address"
                                       :class="{invalid: $v.companyProfile.address.$error}"
                                >
                                <div class="red" v-if="!$v.companyProfile.address.required">{{$t('company.validation.address')}}</div>
                                <div class="red" v-if="!$v.companyProfile.address.maxLength">{{$t('company.validation.addressMax')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.phoneNumber1')}} <span class="red">*</span></label>
                                <the-mask type="text" class="form-control"
                                          mask="(##) ### ## ##"
                                          masked="masked"
                                          v-model="companyProfile.phoneNumber"
                                          :class="{invalid: $v.companyProfile.phoneNumber.$error}"
                                ></the-mask>
                                <div class="red" v-if="!$v.companyProfile.phoneNumber.required">{{$t('company.validation.phoneNumber')}}</div>
                            </div>

                            <div class="form-group">
                                <label>{{$t('company.field.province')}} <span class="red">*</span></label>
                                <v-select
                                    label="name"
                                    v-model="companyProfile.province"
                                    :filterable="false"
                                    :options="provinces"
                                    @search="onProvinceSearch"
                                    @search:focus="onProvinceFocus"
                                >
                                  <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                                  <div class="red" v-if="!$v.companyProfile.province.required">{{ $t("user.validation.province") }}</div>
                            </div>

                            <div class="form-group">
                                <label>{{$t('company.field.region')}} <span class="red">*</span></label>
                                <v-select
                                    label="name"
                                    v-model="companyProfile.region"
                                    :filterable="false"
                                    :options="regions"
                                    @search="onRegionSearch"
                                    @search:focus="onRegionFocus"
                                >
                                  <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                                  <div class="red" v-if="!$v.companyProfile.region.required">{{ $t("user.validation.region") }}</div>
                            </div>

                            <div class="form-group">
                                <label>{{$t('company.field.phoneNumber2')}} <span class="red">*</span></label>
                                <the-mask type="text" class="form-control"
                                          mask="+(998) ## ###-##-##"
                                          masked="masked"
                                          v-model="companyProfile.phoneNumber1"
                                          :class="{invalid: $v.companyProfile.phoneNumber1.$error}"
                                ></the-mask>
                                <div class="red" v-if="!$v.companyProfile.phoneNumber1.required">{{$t('company.validation.phoneNumber1')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.email')}} <span class="red">*</span></label>
                                <input type="email" class="form-control"
                                       v-model="companyProfile.email"
                                       :class="{invalid: $v.companyProfile.email.$error}"
                                >
                                <div class="red" v-if="!$v.companyProfile.email.required">{{$t('company.validation.email')}}</div>
                                <div class="red" v-if="!$v.companyProfile.email.email">{{$t('company.validation.emailConfirm')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.webSite')}} <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="companyProfile.webSite"
                                       :class="{invalid: $v.companyProfile.webSite.$error}"
                                >
                                <div class="red" v-if="!$v.companyProfile.webSite.required">{{$t('company.validation.webSite')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.accountNumber')}} <span class="red">*</span></label>
                                <the-mask type="text" class="form-control"
                                          mask="#### #### #### #### ####"
                                          masked="masked"
                                          v-model="companyProfile.accountNumber"
                                          :class="{invalid: $v.companyProfile.accountNumber.$error}"
                                ></the-mask>
                                <div class="red" v-if="!$v.companyProfile.accountNumber.required">{{$t('company.validation.accountNumber')}}</div>
                                <div class="red" v-if="!$v.companyProfile.accountNumber.minLength">{{$t('company.validation.accountNumberConfirm')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.identificationNumber')}} <span class="red">*</span></label>
                                <the-mask type="text" class="form-control"
                                          mask="#########"
                                          masked="masked"
                                          v-model="companyProfile.identificationNumber"
                                          :class="{invalid: $v.companyProfile.identificationNumber.$error}"
                                ></the-mask>
                                <div class="red" v-if="!$v.companyProfile.identificationNumber.required">{{$t('company.validation.identificationNumber')}}</div>
                                <div class="red" v-if="!$v.companyProfile.identificationNumber.minLength">{{$t('company.validation.identificationNumberConfirm')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.interBranchTurnover')}} <span class="red">*</span></label>
                                <the-mask type="text" class="form-control"
                                          mask="#####"
                                          masked="masked"
                                          v-model="companyProfile.interBranchTurnover"
                                          :class="{invalid: $v.companyProfile.interBranchTurnover.$error}"
                                ></the-mask>
                                <div class="red" v-if="!$v.companyProfile.interBranchTurnover.required">{{$t('company.validation.interBranchTurnover')}}</div>
                                <div class="red" v-if="!$v.companyProfile.interBranchTurnover.minLength">{{$t('company.validation.interBranchTurnoverConfirm')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.xxtut')}} <span class="red">*</span></label>
                                <the-mask type="text" class="form-control"
                                          mask="#####"
                                          masked="masked"
                                          v-model="companyProfile.xxtut"
                                          :class="{invalid: $v.companyProfile.xxtut.$error}"
                                ></the-mask>
                                <div class="red" v-if="!$v.companyProfile.xxtut.required">{{$t('company.validation.xxtut')}}</div>
                                <div class="red" v-if="!$v.companyProfile.xxtut.minLength">{{$t('company.validation.xxtutConfirm')}}</div>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.bankName')}} <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="companyProfile.bankName"
                                       :class="{invalid: $v.companyProfile.bankName.$error}"
                                >
                                <div class="red" v-if="!$v.companyProfile.bankName.required">{{$t('company.validation.bankName')}}</div>
                            </div>

                              <div class="form-group">
                                <div class="form-check checkbox-inline">
                                  <label class="form-check-label pl-0">
                                    <input class="form-check-input" type="checkbox"
                                           v-model="companyProfile.qqs"
                                           name="qqc">
                                    <span class="form-check-sign"></span>
                                    {{$t('company.field.qqs')}}
                                  </label>
                                </div>

                          </div>
                            <div class="form-group">
                                <label>{{$t('company.field.director')}}</label>
                                <div v-if="companyProfile.currentDirector.user!=null">{{companyProfile.currentDirector.user.fullName}}</div>
                              <router-link tag="button"
                                           class="all-btn edit-btn ml-auto mt-3"
                                           v-if="hasPermission('COMPANY_REGISTRATION_CERTIFICATE_ADD') && !hasCreate"
                                           :to="{path: '/company/director'}">
                                <i class="fa fa-edit"></i>
                                <span>{{$t('director.titleEdit')}}</span>
                              </router-link>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <div class="form-check checkbox-inline">
                                    <label class="form-check-label pl-0">
                                        <input class="form-check-input" type="checkbox"
                                               v-model="companyProfile.hasEsp"
                                               name="hasEsp">
                                        <span class="form-check-sign"></span>
                                        {{$t('company.field.hasEsp')}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-12">
                            <div class="text-right">
                                <router-link tag="button"
                                        class="all-btn edit-btn ml-auto"
                                        v-if="hasEdit && hasPermission('V2_COMPANY_EDIT') && !hasCreate"
                                        :to="{path: '/company/edit', query: {isCreate: true}}"
                                >
                                    <i class="fa fa-edit"></i>
                                    <span>{{$t('company.field.companyEdit')}}</span>
                                </router-link>
                                <router-link tag="button"
                                        class="all-btn add-btn"
                                        v-else-if="hasPermission('V2_COMPANY_ADD') && !hasCreate"
                                        :to="{path: '/company/add', query: {isCreate: true}}"
                                >
                                    <i class="fa fa-plus"></i>
                                    <span>{{$t('company.field.companyAdd')}}</span>
                                </router-link>
                                <button class="all-btn"
                                        v-if="hasCreate && hasPermission('V2_COMPANY_ADD')"
                                        @click="save"
                                        :disabled="processing"
                                >
                                    <i class="fa fa-check"></i>
                                    <span>{{$t('action.save')}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import DropZone from '@/views/dropZone/DropZone'
import {TheMask} from 'vue-the-mask';
import {email, maxLength, minLength, required} from 'vuelidate/lib/validators';
import initFilterModel from "@/shared/filter";

export default {
    name: "CompanyProfileEdit",
    components: {
        DropZone,
        TheMask
    },
    data() {
        return {
            processing: false,
            companyProfile: {
                id: null,
                name: '',
                nameRu: '',
                shortName: '',
                description: '',
                address: '',
                phoneNumber: '',
                phoneNumber1: '',
                email: '',
                webSite: '',
                accountNumber: '',
                identificationNumber: '',
                interBranchTurnover: '',
                xxtut: '',
                bankName: '',
                hasEsp: true,
                companyLogo: {},
                logos: [],
                currentDirector: {},
                province: {},
                region: {},
                provinceId: "",
                regionId: '',
                qqs: false
            },
            employees: [],
            companyLogo: [],
            filterProvince: initFilterModel(),
            filterRegion: initFilterModel(),
            provinces: [],
            regions: [],
        }
    },
    validations() {
        return {
            companyProfile: {
                name: {
                    required,
                    maxLength: maxLength(255)
                },
                nameRu: {
                    required,
                    maxLength: maxLength(255)
                },
                shortName: {
                    required,
                    maxLength: maxLength(255)
                },
                description: {
                    required,
                    maxLength: maxLength(255)
                },
                address: {
                    required,
                    maxLength: maxLength(255)
                },
                phoneNumber: {
                    required
                },
                phoneNumber1: {
                    required
                },
                email: {
                    required,
                    email
                },
                webSite: {
                    required
                },
                accountNumber: {
                    required,
                    minLength: minLength(24)
                },
                identificationNumber: {
                    required,
                    minLength: minLength(9)
                },
                interBranchTurnover: {
                    required,
                    minLength: minLength(5)
                },
                xxtut: {
                    required,
                    minLength: minLength(5)
                },
                bankName: {
                    required
                },
                companyLogo: {
                    id: {
                        required
                    }
                },
                province:{
                  required:required
                },
                region:{
                  required:required
                },
            }
        }
    },
    computed: {
        hasEdit() {
            return this.companyProfile.id && this.companyProfile.id > 0
        },
        hasCreate() {
          return this.$route.query.isCreate != null ? Boolean(this.$route.query.isCreate) : false
        }
    },
    methods: {
        initData() {
            this.$http.get('/company/view')
                .then(res => {
                    this.companyProfile = res.data;
                }, err => {
                    console.log(err);
                })
          this.initProvince();
        },
        save() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }

            this.processing = true;
            this.companyProfile.regionId = this.companyProfile.region.id;
            this.$http.post('/company/edit', this.companyProfile)
                .then(res => {
                    this.processing = false;
                    if (res.status === 200) {
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.company.success'),
                            type: 'success'
                        });

                        this.$router.push('/company/profile')
                    }
                }, ()=> {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('messages.company.error'),
                        type: 'error'
                    });
                    this.processing = false;
                });
        },
        initProvince() {
          const vm = this;
          const promises = [
            this.$http.get('province/init')
          ];
          Promise.all(promises).then(function (values) {
            const initData = values[0].data;
            vm.provinces = initData.provinces;
            vm.getProvinceGetRegions();
          });
        },
        getProvinceGetRegions() {
          if (this.provinces && this.provinces.length > 0) {
            this.provinces.forEach((province) => {
              if (province.id === this.companyProfile.provinceId) {
                this.companyProfile.province = province;
                this.regions = province.regions;
                console.log(this.regions)

                province.regions.forEach((region) => {
                  if (region.id === this.user.regionId) {
                    this.companyProfile.region = region;
                  }
                });
              }
            });
          }

        },
        onProvinceSearch(searchTxt, loading) {
          loading(true);
          this.provinces = [];
          this.filterProvince.search = searchTxt;
          this.$http.post('/province/list', this.filterProvince)
              .then(res => {
                this.provinces = res.data.data;
                console.log("this.provinces", this.provinces)
                loading(false);
              }, err => {
                console.log(err);
              });
        },
        onProvinceFocus() {
          this.provinces = [];
          this.filterProvince.search = '';
          this.$http.post('/province/list', this.filterProvince)
              .then(res => {
                this.provinces = res.data.data;
              }, err => {
                console.log(err);
              });
        },
        onRegionSearch(searchTxt, loading) {
          loading(true);
          this.regions = [];
          this.filterRegion.provinceId = this.companyProfile.province.id;
          this.$http.post('/region/search', this.filterRegion)
              .then(res => {
                this.regions = res.data.data;
                loading(false);
              }, err => {
                console.log(err);
              });
        },
        onRegionFocus() {
          this.regions = [];
          this.filterRegion.provinceId = this.companyProfile.province != null ? this.companyProfile.province.id : null;
          this.$http.post('/region/search', this.filterRegion)
              .then(res => {
                this.regions = res.data.data;
              }, err => {
                console.log(err);
              });
        },

    },
    created() {
        this.initData();
      this.filterProvince.page.size = 1000;
      this.filterRegion.page.size = 1000;
    }
}
</script>

<style scoped>
    .profile {
        background-color: #2980B9;
    }

    .card .card-header span {
        color: white;
        font-weight: bold;
        font-size: 15px;
    }

    .card .card-footer {
        background-color: #f2f2f2;
    }
</style>